







































































import CreateDialog from '@/components/CreateDialog.vue'

import mixins from 'vue-typed-mixins'
import { editMixin } from '@/utils/mixins/editMixin'
import { crudMixin } from '@/utils/mixins/crudMixin'
import { RemittancePrice } from '@/utils/interfaces/remittance.interface'
import { VueForm } from '@/utils/interfaces'
import { number } from '@/utils/validators'

export default mixins(editMixin, crudMixin).extend({
  components: {
    appCreateDialog: CreateDialog,
  },
  props: {
    service: {
      type: String,
      default: 'remittance.remittance',
      required: false,
    },
    canDeliver: {
      type: Boolean,
      default: true,
    },
    poster: Function,
  },
  data() {
    return {
      rules: {
        required: (v: number | string) =>
          !!v || v === 0 || this.$t('validation.field-required'),
        number: (v: string | number) =>
          number(v.toString()) || this.$t('validation.must-be-a-number'),
        positive: (v: number) =>
          v >= 0 || this.$t('validation.must-be-positive'),
      },
      crud: {} as RemittancePrice,
      defaultCrud: {
        agency: '',
        min_amount: 0,
        max_amount: 0,
        percent: 0,
        can_deliver: false,
        remittance_without_balance: true,
      } as RemittancePrice,
      loading: false,
      fields: ['min_amount', 'max_amount', 'percent'],
    }
  },
  methods: {
    async onSuccess() {
      try {
        const form = this.$refs.form as VueForm
        if (!form.validate()) return
        this.loading = true
        const response = await this.poster(this.crud)
        this.$emit('new-item', response.data)
        this.$emit('input', false)
        this.resetCrud()
        form.resetValidation()
      } finally {
        this.loading = false
      }
    },
  },
})
